const demographicData = {
  //Personal Information
  firstName: "",
  lastName: "",
  gender: "",
  dateOfBirth: "",
  age: "",
  height: "",
  weight: "",

  educationLevel: "",
  occupation: "",
  workScheduleType: "",
  workHoursPerDay: "",
  workHoursPerWeek: "",

  //Medical Information
  chronicDiseases: "",
  pastSurgeries: "",
  pastSurgeriesNote: "",
  currentMedications: "",
  currentMedicationsNote: "",
  sleepingPills: "",
  sleepingPillsFrequency: "",

  smokingStatus: "",
  alcoholConsumption: "",
  caffeineConsumption: "",
  weightChangeLastYear: "",
  weightChangeNote: "",
  exerciseStatus: "",
  familySleepDisorders: "",
  familySleepDisordersNote: "",

  sleepingPosition: "",

  symptoms: "",
  symptomsNote: "",
  symptomsDuration: "",

  //Epworth Sleepiness Scala
  readingSleepiness: "",
  tvWatchingSleepiness: "",
  publicPlaceSleepiness: "",
  longTripPassengerSleepiness: "",
  afterLunchSleepiness: "",
  conversationSleepiness: "",
  afternoonRestSleepiness: "",
  trafficStopSleepiness: "",

  //SleepSchedule
  weekdayBedtime: "",
  weekdayWakeupTime: "",
  weekdayFallAsleepTime: "",
  weekdayAverageSleepHours: "",
  weekdayNightAwakenings: "",
  weekdayNightAwakeningsCount: "",
  weekdayNightAwakeDuration: "",

  weekendBedtime: "",
  weekendWakeupTime: "",
  weekendFallAsleepTime: "",
  weekendAverageSleepHours: "",
  weekendNightAwakenings: "",
  weekendNightAwakeningsCount: "",
  weekendNightAwakeDuration: "",

  napStatus: "",
  napCount: "",
  napTime: "",

  worksShifts: "",
  shiftStartTime: "",
  shiftEndTime: "",
  shiftDaysPerWeek: "",
  shiftDays: "",
  shiftDayBedtime: "",
  shiftDayWakeupTime: "",

  nonShiftDayBedtime: "",
  nonShiftDayWakeupTime: "",

  //SymptomAnalysis
  difficultyFallingAsleep: "",
  legCrampsAtNight: "",
  wakesUpAtNight: "",
  nightWakeReason: "",
  nightWakeFrequency: "",
  nightWakeTime: "",
  difficultyReturningToSleep: "",

  nightSweats: "",
  legCrampsOrCrawlingSensation: "",
  confusionBetweenRealityAndDream: "",
  snoring: "",
  snoringLoudness: "",
  breathingPausesDuringSleep: "",
  chokingSensationDuringSleep: "",
  fistClenchingDuringSleep: "",
  limbJerkingDuringSleep: "",
  restlessnessAndSweatingDuringSleep: "",
  sleepwalkingOrTalking: "",

  feelingAfterWakingUp: "",
  overallSleepQuality: "",
};

export default demographicData;
